import { Auxiliares } from "../../types/TabelasAuxiliares/Auxiliares";
import api from "../../utils/api";
import { INDICATOR_TYPE_URL } from "../../utils/endpoints";

export async function getIndicatorType() {
  try {
    const response = await api.get(`${INDICATOR_TYPE_URL}?OnlyActive=true`);
    const data: Auxiliares[] = response.data.map((option: Auxiliares) => ({
      id: option.id,
      name: option.name,
      code: option.code,
      isActive: option.isActive,
    }));
    return data;
  } catch (error) {
    throw error;
  }
}
